import useMutation from "src/hooks/useMutation";

function useWTImportCode(id) {
  return useMutation({
    path: `/api/v1/warehouse-transfers/${id}/transfer-details/import`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouse-transfers/${id}`,
      shouldRevalidate: true,
    },
  });
}

export default useWTImportCode;
